import { addressFormat } from './address-format';

export const US = {
  validator: null,
  addressFormat,
};
